/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.0",
  "gitBuildTime": "2026-07-31T17:39:52.679Z",
  "gitBuildVersion": "2.9.0",
  "gitCommitId": "a32454b",
  "gitCommitIdFull": "a32454bcd2b2b8e2d19da009ad0fb2a2e712325c",
  "gitCommitTime": "2026-07-31T17:35:17.000Z",
  "version": "2.9.0-2026-07-31T17:35:17.000Z-(a32454b)"
};
